import React from 'react'
import { className } from '../type'

type Props = {
    source: string;
} & className

function Iframe({source}:Props) {
  return (
    <iframe className='absolute top-0 w-full h-full' src={source} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
  )
}

export default Iframe